import i18n from '../../src/i18n/translate';

export default (title, prefix = "Foundry - %s") => {
  document.title = i18n.t(prefix, { postProcess: 'sprintf', sprintf: [title] });
};
